<script setup lang="ts">
/**
 * TODO: Add an spacing between banner and circle menu
 */

import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import Autoplay from 'embla-carousel-autoplay';
import emblaCarouselVue from 'embla-carousel-vue'
import { useBannersStore } from '@/stores/banners';
import type { CarouselApi } from 'shadcn-vue';

const route = useRoute();
const carouselApi = ref<CarouselApi | null>(null);
const bannersStore = useBannersStore();
const isMobile = computed(() => isMobileDevice());
const isTransitioning = ref(false);
emblaCarouselVue.globalOptions = { loop: true }

const handleInit = (api: CarouselApi) => {
  carouselApi.value = api;
  api.scrollTo(bannersStore.currentIndex);
};

watch(() => carouselApi.value, (api) => {
  if (!api) return;

  api.on('select', () => {
    bannersStore.setCurrentIndex(api.selectedScrollSnap());
  });
});

watch(() => route.path, () => {
  isTransitioning.value = true;
  setTimeout(() => {
    isTransitioning.value = false;
  }, 700);
});
</script>

<template>

  <Carousel v-if="bannersStore.processedBanners.length" class="-mx-6 -mt-4 sm:-mt-6 lg:mx-0 lg:mt-0" :class="[
    'transition-all duration-500 ease-in-out transform',
    isTransitioning ? 'translate-y-8 opacity-0 scale-98' : 'translate-y-0 opacity-100 scale-100'
  ]" @init="handleInit" :plugins="[Autoplay({ delay: 4000 })]">
    <CarouselContent class="mb-5">
      <CarouselItem v-for="(banner, index) in bannersStore.processedBanners" :key="index">
        <nuxt-link :to="banner.url" @click="(e) => bannersStore.handleBannerClick(banner.url, e)">
          <img :src="bannersStore.getImageUrl(banner, isMobile)" :alt="`carousel-image-${index}`"
            class="aspect-[884/327] w-full rounded-md" />
        </nuxt-link>
      </CarouselItem>
    </CarouselContent>
    <CarouselPrevious class="left-4 z-10" />
    <CarouselNext class="right-4 z-10" />
  </Carousel>
  <div v-else class="flex items-center justify-center aspect-[884/327] shimmer-effect rounded-md mb-5" />
</template>

<style scoped>
.scale-98 {
  transform: scale(0.98) translateY(2rem);
}

.translate-y-8 {
  transform: translateY(1rem);
}
</style>